module.exports = __webpack_public_path__ + "static/img/bcg_unit3.b3f2e0fb.png";